import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { DateAdapter } from '@angular/material/core';
import { MatSidenav } from '@angular/material/sidenav';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import 'moment/locale/fr';
import { StorageService } from '../shared/services/storage/storage.service';
import { UserService } from '../shared/services/user/user.service';
import { MOMENT_TOKEN } from './shared/shared.module';
import { TaskService } from './v2-node-api/services/task.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  public loadingPage: boolean = true;
  @ViewChild('content') content;
  @ViewChild('rightSidenav') public sidenav: MatSidenav;

  constructor(
    private storage: StorageService,
    private user: UserService,
    private router: Router,
    private dateAdapter: DateAdapter<any>,
    @Inject(MOMENT_TOKEN) public moment,
    private taskService: TaskService,
    private translateService: TranslateService
  ) {
  }

  public ngOnInit() {
    this.loadingPage = true;
    this.dateAdapter.setLocale('fr');
    registerLocaleData(localeFr, 'fr');

    this.moment.locale('fr');

    this.translateService.setDefaultLang(localStorage.getItem('lang') || 'fr');

    this.user.pendingWhoAmI = this.storage
      .get({ key: 'token' })
      .then(res => {
        if (res) {
          return this.user.whoAmI();
        }
      })
      .then((res) => {
        if (res) {
          this.taskService.getAll().subscribe(tasks => { });
        }
      })
      .catch(() => {
        localStorage.removeItem('token');
        localStorage.removeItem('bearer');
        localStorage.removeItem('validity');
        this.user.logout();
        this.goToLogin();
      })
      .finally(() => {
        this.loadingPage = false;
      });
  }

  private goToLogin() {
    this.router.navigate(['/connexion']);
  }
}
